interface Config {
  tenant: string;
  appId: string;
  identityExperienceFrameworkAppId?: string;
  proxyIdentityExperienceFrameworkAppId?: string;
  b2cExtensionsAppAppId?: string;
  b2cExtensionsAppObjectId?: string;
}

export const PROD: Config = {
  tenant: 'coriolisprod',
  appId: '90d8530f-d263-4f63-8115-ffd0475420cc',
  identityExperienceFrameworkAppId: 'c65143ce-4e31-49d3-8108-a7daf1daf2ea',
  proxyIdentityExperienceFrameworkAppId: '7813985e-01fe-4780-a7cc-564262cc15c5',
  b2cExtensionsAppAppId: '3db7577e-8ba7-48e6-82c5-eb337b8ed8cd',
  b2cExtensionsAppObjectId: '2581c830-2ce2-4df3-b673-004073617276',
};

export const SANDPIT: Config = {
  tenant: 'coriolisotfpsandpit',
  appId: '1657e3e5-8b8e-47c2-8de3-566ad0f88658',
  identityExperienceFrameworkAppId: '5b67e9d2-536f-4e5f-a39d-9192c966b857',
  proxyIdentityExperienceFrameworkAppId: 'b9cb2f5b-e539-4240-b7bd-01034b604421',
  b2cExtensionsAppAppId: '1a44e7e0-544d-44bf-a237-83cc99880155',
  b2cExtensionsAppObjectId: '42f0eb17-034e-40d1-926e-bc35b7561d30',
};

export const STAGING: Config = {
  tenant: 'coriolisotfpstaging',
  appId: 'c76002ca-de87-454d-8889-56e87cf36fb4',
  identityExperienceFrameworkAppId: '327c5492-d8d2-467c-9559-3105f8f92e9b',
  proxyIdentityExperienceFrameworkAppId: 'f9f199f4-c405-4643-8635-08793cd64dcd',
  b2cExtensionsAppAppId: '44c0cc2b-1e9a-461a-a47a-74f2776b1bc3',
  b2cExtensionsAppObjectId: '810257c4-f126-4da4-a4c1-6504eec99d16',
};

export const DEV: Config = {
  tenant: 'coriolisotfpdev',
  appId: '1031b725-30dd-48b4-88b5-301ee44b342e',
  identityExperienceFrameworkAppId: 'b0e59bfa-073a-4397-acea-2809d2019795',
  proxyIdentityExperienceFrameworkAppId: '95cd251a-a1c9-48f7-8f86-29b205139aac',
  b2cExtensionsAppAppId: '5974a286-9190-4d1c-a848-6fb1b94e5d3b',
  b2cExtensionsAppObjectId: 'aa0ec517-23e2-4fea-bbca-a47f5994fd24',
};

// the one used for localhost
const localDefaultInstance = DEV;

export const APPLICATION_NAMESPACE: string =
  process.env.REACT_APP_AAD_B2C_APPLICATION_NAMESPACE || localDefaultInstance.tenant;
export const APPLICATION_ID: string =
  process.env.REACT_APP_AAD_B2C_APPLICATION_ID || localDefaultInstance.appId;
